import useSelectedBusiness from './useSelectedBusiness';
import useSelectedCommunity from '../community/useSelectedCommunity';

export default function useIsMainBusinessCommunity(): boolean {
  const selectedBusiness = useSelectedBusiness();
  const selectedCommunity = useSelectedCommunity();

  if (process.env.REACT_APP_APPLICATION_VERSION !== 'BUSINESS') {
    return false;
  }

  return !!(
    selectedBusiness?.community &&
    selectedCommunity &&
    selectedBusiness.community.id === selectedCommunity.id
  );
}
